import type { InjectionKey } from 'vue'

/** Where each upload list's slots stand, so feedback shows at the control that was used. */
export interface UploadStatus {
  /** Uploads in flight, counted per slot kind. */
  uploading: Map<string, number>
  /** Documents whose removal is in flight. */
  removing: Set<number>
  /** The file just added, highlighted briefly so the eye lands on it. */
  justAdded: number | undefined
  /** A failed upload (anchored by slot kind) or removal (by document). */
  failure: { kind?: string; documentId?: number; message: string } | undefined
}

export const uploadStatusKey: InjectionKey<UploadStatus> = Symbol('uploadStatus')
